import React, { useContext, useEffect, useState } from "react";
import DocUpload from "../modules/DocUpload";
import { useDispatch, useSelector } from "react-redux";
import { addEduInfo } from "./redux/actions";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { modifyPage } from "../ApplicationForm/redux/actions";
import Button from "../modules/Button";
import GradientLoader from "../modules/Loader";
import StaticItem from "../modules/StaticItem";
import ModalComponent from "../modules/Modal";

function EducationBtm(props) {
  const dispatch = useDispatch();
  const [err1, showErr1] = useState(false);
  const status = useSelector((state) => state.status.statusData);

  const [err2, showErr2] = useState(false);
  const [uploading1, setUploading1] = useState(false);
  const [uploading2, setUploading2] = useState(false);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const education = useSelector((state) => state.education.eduInfo);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [admissionLetter, setadmissionLetter] = useState(null);
  const [paymentReciept, setPaymentReciept] = useState(null);

  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      props.showModal("File with double extensions is not allowed.");

      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }

  const addData = (type, value) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "application/msword",
    ];
    let isFormat = false;
    value = validateFileName(value);
    if (value) {
      if (value !== null && value.size / 1024 / 1024 > 2) {
        value = null;
        if (type === "admissionLetter") {
          showErr1(true);
          // setTimeout(() => showErr1(false), 3000);
        } else {
          showErr2(true);
          // setTimeout(() => showErr2(false), 3000);
        }
      } else {
        for (let i in allowedTypes) {
          if (value.type === allowedTypes[i]) {
            isFormat = true;
          }
        }
      }
      if (type === "admissionLetter") {
        if (!isFormat) {
          alert("Only PDF, JPEG, PNG, and Word files are allowed.");
          // setDoc(null); // Clear the file input
          setadmissionLetter(null);
        } else {
          setadmissionLetter(value);
        }
      } else {
        if (!isFormat) {
          alert("Only PDF, JPEG, PNG, and Word files are allowed.");
          // setDoc(null); // Clear the file input
          setPaymentReciept(null);
        } else {
          setPaymentReciept(value);
        }
        // setPaymentReciept(value);
      }
    } else if (type === "admissionLetter") {
      setadmissionLetter(null);
    } else {
      setPaymentReciept(null);

      // setPaymentReciept(value);
    }

    //dispatch(addEduInfo({ type: type, value: value }));
  };
  const getDocs = async () => {
    const docs1 = await api.getDocuments(
      "application",
      tokenData.applicationData.id,
      tokenData.token
    );
    dispatch(addTokenInfo(["docs", docs1.data]));
  };

  const delDoc = async (type, e) => {
    e = validateFileName(e);
    if (e) {
      try {
        let file;
        if (docs) {
          file = docs[type];
        }
        console.log(file);
        if (file) {
            setUploading1(true);
          const formData = new FormData();
          formData.append("file", e);
          formData.append("name", e.name);
          formData.append("size", e.size);
          formData.append("documentType", type);
          formData.append("fileType", e.type.split("/")[1]);
          if (file) {
            formData.append("id", file.id);
          }
          const result = await api.uploadDocument(
            "application",
            tokenData.applicationData.id,
            tokenData.token,
            formData
          );
          if (result?.statusCode == 200) {
            props.showModal("Your Document has been uploaded successfully!");
          }
          getDocs();
            setUploading1(false);
        }
      } catch (err) {
        alert("Sorry! Something went wrong, Please try again.");
        console.error("Error deleting document:", err);
          setUploading1(false);
      }
    }
  };
  const handleUpload = async (type, e) => {
    e = validateFileName(e);
    console.log(JSON.stringify(tokenData.docs));
    console.log(type);

    if(e){
  setUploading1(true);

  try {
    const formData = new FormData();
    formData.append("file", e);
    formData.append("name", e.name);
    formData.append("size", e.size);
    formData.append("documentType", type);
    formData.append("fileType", e.type.split("/")[1]);
    const result = await api.uploadDocument(
      "application",
      tokenData.applicationData.id,
      tokenData.token,
      formData
    );
    if (result?.statusCode == 200) {
      props.showModal("Your Document has been uploaded successfully!");
    }
    getDocs();
    setUploading1(false);
  } catch (error) {
    setUploading1(false);

    alert("Sorry! Something went wrong, Please try again.");
    getDocs();

    console.error("Error uploading document:", error);
  }
}
    // }
    // else {
    //   setUploading2(true);
    //   const formData = new FormData();
    //   formData.append("file", paymentReciept);
    //   formData.append("name", paymentReciept.name);
    //   formData.append("size", paymentReciept.size);
    //   formData.append("documentType", "paymentReciept");
    //   formData.append("fileType", paymentReciept.type.split("/")[1]);
    //   const result = await api.uploadDocument(
    //     "application",
    //     tokenData.applicationData.id,
    //     tokenData.token,
    //     formData
    //   );
    //   const docs2 = await api.getDocuments(
    //     "application",
    //     tokenData.applicationData.id,
    //     tokenData.token
    //   );
    //   dispatch(addTokenInfo(["docs", docs2.data]));
    //   setUploading2(false);

    //   dispatch(modifyPage("Yes"));

    //   setUploading1(false);
    // }
    // }
  };
  useEffect(() => {
    console.log("status", status);
  }, [education]);
  return (
    <div className="edu-btm">
      <div
        className={`field-row upload
      
      ${docs?.admissionLetter && "doc-col"}
      `}
      >
        {docs?.admissionLetter ? (
          <div className="doc-item">
            <StaticItem
              onDelete={(e) => delDoc("admissionLetter", e)}
              isEditable={true}
              doc={docs?.admissionLetter}
              type={"doc"}
              title={"Admission Letter"}
              docUrl={docs?.admissionLetter?.documentUrl}
              value={docs?.admissionLetter.name}
              size={Math.floor(docs?.admissionLetter?.size / 1024)}
            />
          </div>
        ) : (
          <div className="file-upload-container">
            <DocUpload
              noTooltip={true}
              placeholder={"Upload Admission letter"}
              onChange={(e) => handleUpload("admissionLetter", e)}
              title={"Admission Letter"}
              value={admissionLetter?.name ? admissionLetter : null}
            />
            {/* {admissionLetter?.name ? (
              <Button
                onClickHandler={() => handleUpload("admissionLetter")}
                value={"Upload"}
                type={"contained"}
              />
            ) : null} */}
          </div>
        )}
        {(err1 ||status?.eduList?.rest?.includes("admissionLetter") )&& (
          <p className="set-sub-title">
           {err1 ? "File size exceeds the maximum upload size limit.":"Required"}
          </p>
        )}
      </div>
      <div className={`field-row upload ${docs?.paymentReciept && "doc-col"}`}>
        {docs?.paymentReciept ? (
          // <div>{docs?.paymentReciept.name}</div>
          <div className="doc-item">
            <StaticItem
              onDelete={(e) => delDoc("paymentReciept", e)}
              isEditable={true}
              type={"doc"}
              doc={docs?.paymentReciept}
              title={"Payment Reciept"}
              docUrl={docs?.paymentReciept?.documentUrl}
              value={docs?.paymentReciept?.name}
              size={Math.floor(docs?.paymentReciept?.size / 1024)}
            />
          </div>
        ) : (
          <div className="file-upload-container">
            <DocUpload
              noTooltip={true}
              placeholder={"Upload fee payment Reciept"}
              title={"Fee Payment Receipt"}
              value={paymentReciept?.name ? paymentReciept : null}
              onChange={(e) => handleUpload("paymentReciept", e)}
            />
            {/* <button
                    className="upload-button"
                    onClick={() => handleUpload("paymentReciept")}
                    disabled={uploading2}
                >
                  {uploading2 ? <span className="spinner"></span> : "Upload"}
                </button> */}
            {/* {paymentReciept ? (
              <Button
                onClickHandler={() => handleUpload("paymentReciept")}
                value={"Upload"}
                type={"contained"}
              />
            ) : null} */}
          </div>
        )}
         {(err2 ||status?.eduList?.rest?.includes("paymentReciept") )&& (
          <p className="set-sub-title">
           {err2 ? "File size exceeds the maximum upload size limit.":"Required"}
          </p>
        )}
      </div>
      {(uploading2 || uploading1) && (
        <ModalComponent
          className={"loader-model"}
          show={uploading2 || uploading1}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default EducationBtm;
